<sl-title title="Banking Info Detail"></sl-title>
<div *ngIf="entityLoaded" class="bank-detail-page">
	<div class="linq-breadcrumbs breadcrumb-row">
		<div>
			<a [routerLink]="listingPagePath">Banking Info</a>
			<span class="bank-name">{{ entity.ShortName }} - {{ entity.BankName }}</span>
		</div>
		<span class="current-balance">Current Balance: {{ entity.CurrentBalance | currency:'USD':'symbol':'1.2-2' }}</span>
	</div>
	<div class="bank-detail-content">
		<mat-card class="bank-detail-card">
			<mat-tab-group class="linq-tab-bar" [(selectedIndex)]="selectedTabIndex" [preserveContent]="true">
				<mat-tab label="{{ tabs.BankProfile }}">
					<bank-profile [readOnly]="isReadOnly" [(entity)]="bankEntity" (tabChange)="onTabContentChange($event)"></bank-profile>
				</mat-tab>
				<mat-tab label="{{ tabs.Addresses }}">
					<ng-template matTabContent>
						<bank-addresses [readOnly]="isReadOnly" (tabChange)="onTabContentChange($event)"></bank-addresses>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ tabs.CheckConfig }}">
					<ng-template matTabContent>
						<bank-check-config [readOnly]="isReadOnly" [(entity)]="bankEntity" (tabChange)="onTabContentChange($event)"></bank-check-config>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ tabs.CashAccounts }}">
					<ng-template matTabContent>
						<bank-cash-accounts [readOnly]="isReadOnly" [bankId]="entity.Id" (currentBalanceChange)="onCurrentBalanceChange($event)"
							(tabChange)="onTabContentChange($event)">
						</bank-cash-accounts>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ tabs.Sites }}">
					<ng-template matTabContent>
						<bank-sites [readOnly]="isReadOnly" (tabChange)="onTabContentChange($event)"></bank-sites>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ tabs.BankReconSetup }}">
					<ng-template matTabContent>
						<bank-recon-setup [readOnly]="isReadOnly" (tabChange)="onTabContentChange($event)"></bank-recon-setup>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ tabs.PositivePaySetup }}">
					<ng-template matTabContent>
						<positive-pay-setup [readOnly]="isReadOnly" (tabChange)="onTabContentChange($event)"></positive-pay-setup>
					</ng-template>
				</mat-tab>
			</mat-tab-group>
		</mat-card>
	</div>
</div>
<sl-button-bar *ngIf="tabHasChanges()" (canceled)="cancelChanges()" (submitted)="saveChanges()"></sl-button-bar>
